import {SegmentedControlProps} from "../SegmentedControl/SegmentedControl";
import {Box, Center, SegmentedControl} from "@mantine/core";
import {IconChartDots3, IconDeviceAnalytics, IconTruck} from "@tabler/icons-react";
import {transportMethod} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";

export type HaulMethodSegmentedControlProps = Omit<SegmentedControlProps, 'data'>

export const HaulMethodSegmentedControl = (props: HaulMethodSegmentedControlProps) => {
  const {...rest} = props

  const {t} = useTranslation(["common"])

  return (
    <SegmentedControl
      {...rest}
      data={[
        {
          value: 'all',
          label: (
            <Center>
              <IconDeviceAnalytics size="1rem"/>
              <Box ml={10}>
                {t("common.entity.haulmethod.all", "All")}
              </Box>
            </Center>
          ),
        },
        {
          value: transportMethod.trucking.code,
          label: (
            <Center>
              <IconTruck size="1rem"/>
              <Box ml={10}>
                {t(transportMethod.trucking.displayValue.id, transportMethod.trucking.displayValue.defaultMessage)}
              </Box>
            </Center>
          ),
        },
        {
          value: transportMethod.pipeline.code,
          label: (
            <Center>
              <IconChartDots3 size="1rem"/>
              <Box ml={10}>
                {t(transportMethod.pipeline.displayValue.id, transportMethod.pipeline.displayValue.defaultMessage)}
              </Box>
            </Center>
          ),
        },
      ]}
    />
  )
}
